import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const debitNotesConfigurationValidator = v.object({
  branchId: v.id("branches"),
  correlativeId: v.id("correlatives"),
  autoGenerateCorrelative: v.boolean(),
  internalControl,
});

export const debit_notes_configurations = defineTable(debitNotesConfigurationValidator)
  .index("by_branch_id", ["branchId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_branch", ["internalControl.companyId", "internalControl.branchId"])
  .index("by_branch_and_state", ["internalControl.branchId", "internalControl.state"]);
